/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";

export const SpinnerLoading = () => {
    return(
        <div className="container m-5 d-flex justify-content-center" style={{ height: 550 }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">
                    Loading ...
                </span>
            </div>
        </div>
    );
}